module.exports = __webpack_public_path__ + "908e4d2e/img/search-filter-icon.c4751a52.svg";